
 <template lang="">
 <UserLayout :showNavBar="true"  pageTitle="Modifica dati azienda">
      <template #page-content="props">
        <v-card
                        class="form-card" 
                        outlined 
                        >
        <FrmEditCompany></FrmEditCompany>
        </v-card>
     </template>
 </UserLayout> 
</template>
<script>
import FrmEditCompany from "../components/Management/FrmEditCompany";
import UserLayout from "../layout/UserLayout";
import SessionHelper from "../utils/SessionHelper";
export default {
  mounted(){
    
    SessionHelper.checkRedirects(this.$route.params.companyAlias);
  },
  components: {
    FrmEditCompany,
    UserLayout,
  },
};
</script>
<style lang="">
  
</style> 